import React from "react";
import { CONFIG } from "../config";

const LinearLoader = ({state}) => {
  const containerStyle = {
    width: "100%",
    height: "3px",
    overflow: "hidden",
    position: "relative",
    top: "1px",
  };

  const barStyle = {
    position: "absolute",
    height: "100%",
    width: "30%",
    backgroundColor: CONFIG.colors.primary, // mavi renk
    animation: "move 0.5s infinite ease-in-out",
  };

  return (
    <div style={containerStyle}>
      <div className={`${state == true ? "" : "hidden"}`} style={barStyle}></div>
      <style>{`
        @keyframes move {
          0%   { left: -30%; }
          50%  { left: 50%; width: 40%; }
          100% { left: 100%; width: 30%; }
        }
      `}</style>
    </div>
  );
};


export default LinearLoader;
